module.exports = __webpack_public_path__ + "img/0Q3B3739_Foamcore_MockedUp.bcacb589.jpg";